import ReactDOM from 'react-dom';
import KakuninModal from "../../components/common/KakuninModal";
import rootScope from '../../store/rootScopeStore';
import { getMsg, isEmpty, isNotEmpty, checkIsMobile } from '../../util/util';


const instance = (okFunc, cancelFunc, messageId, message, cancelIsHide, okView, cancelView, okIsHide) => {
    if (document.querySelector('.error-dialog')) return;
    const rootElement = document.getElementById('root');
    const divElement = document.createElement('div');
    divElement.classList.add('error-dialog-contailer');

    let zIndex = 100;
    if (rootScope.modalScopes && rootScope.modalScopes.length) {
        zIndex = rootScope.modalScopes[rootScope.modalScopes.length - 1].zIndex + 10;
    }
    divElement.style.zIndex = zIndex;
    rootElement.appendChild(divElement);
    // OKボタンクリック後の処理
    const onConfirm = () => {
        if (okFunc) okFunc();
        rootScope.modalScopes.pop();
        divElement.remove();
    }

    // Cancelボタンクリック後の処理
    const onCancel = () => {
        if (cancelFunc) cancelFunc();
        rootScope.modalScopes.pop();
        divElement.remove();
    }

    const option = {
        confirm: okView ? onConfirm : undefined,
        cancel: cancelView ? onCancel : undefined,
        cancelIsHide: cancelIsHide,
        okView: okView,
        cancelView: cancelView,
        okIsHide: okIsHide,
        title: messageId,
        message: message,
        zIndex: zIndex,
        model: 'error-dialog-contailer'
    }
    rootScope.modalScopes.push(option);
    ReactDOM.render(<KakuninModal option={option}></KakuninModal>, divElement);
}

const okDialog = (messageId, message, messageParam, okFunc, okBtnView) => {
    // メッセージが設定されていない場合はメッセージIDからメッセージを取得する
    if (isEmpty(message)) message = getMsg(messageId, messageParam);
    // OKボタン表示名称設定
    // OKボタン表示名称に「false」が設定されている場合、OKボタンを表示しない
    let okIsHide = false;
    if (!okBtnView) {
        okIsHide = !okBtnView;
    }
    const okView = isNotEmpty(okBtnView) ? okBtnView : "OK";
    instance(okFunc, null, messageId, message, true, okView, '', okIsHide);
}

const confirmDialog = (messageId, message, messageParam, okFunc, cancelFunc, okBtnView, cancelBtnView) => {
    // メッセージが設定されていない場合はメッセージIDからメッセージを取得する
    if (isEmpty(message)) message = getMsg(messageId, messageParam);

    // OKボタン表示名称設定
    const okView = isNotEmpty(okBtnView) ? okBtnView : "OK";
    // Cancelボタン表示名称設定
    const cancelView = isNotEmpty(cancelBtnView) ? cancelBtnView : "Cancel";
    instance(okFunc, cancelFunc, messageId, message, false, okView, cancelView, false);
}

const dialogService = {
    okDialog,
    confirmDialog
}

export default dialogService;

